import type { IRegisterFormValues } from '../features/register/components/register-form/Register';

const CONSENTS = {
  PHONE: 'phone',
  EMAIL_MARKETING: 'Email_Marketing',
  PUSH_MARKETING: 'Push_Marketing',
  SMS_Marketing: 'SMS_Marketing',
  OVER_16: 'over_16',
  UNDER_16: 'under_16',
  I_CONFIRM_16_YEARS_OLD: 'i_confirm_i_am_16_years_old_or_older',
  PERMISSIONS: 'permissions',
  SINGLE_CHOICE_PREFERENCE: 'single-choice-preference',
};

interface INormalizeSaveMarketingConsentsRequestBody {
  formValues: IRegisterFormValues;
}
export const normalizeSaveMarketingConsentsRequestBody = ({
  formValues,
}: INormalizeSaveMarketingConsentsRequestBody) => {
  return {
    permissions: [
      {
        optionId: CONSENTS.EMAIL_MARKETING,
        selected: formValues.emailMarketing,
      },
      {
        optionId: CONSENTS.PUSH_MARKETING,
        selected: formValues.pushMarketing,
      },
      {
        optionId: CONSENTS.SMS_Marketing,
        selected: formValues.smsMarketing,
      },
    ],
    singleChoicePreferences: [
      {
        reference: CONSENTS.OVER_16,
        selectedChoice:
          formValues.isOver16 === true || formValues.isOver16 === 'on'
            ? CONSENTS.I_CONFIRM_16_YEARS_OLD
            : CONSENTS.UNDER_16,
      },
    ],
  };
};
